import { DeveloperProjectCardWithTabsTemplate } from "../../../../templates";
import { useProject } from "./useProject";

const Project = (): JSX.Element => {
  const { projectDetails, publicProjectDetails, handleBackClick, tabsList, backButtonText } = useProject();

  return (
    <DeveloperProjectCardWithTabsTemplate
      activeElement="Projects"
      pageTitle={projectDetails?.displayName ?? publicProjectDetails?.displayName}
      projectCode={projectDetails?.standard.displayName ?? publicProjectDetails?.standard?.displayName}
      projectVerifier={projectDetails?.validator?.displayName ?? publicProjectDetails?.validator?.displayName}
      projectStatus={projectDetails?.status}
      projectUuid={projectDetails?.uuid}
      tabsList={tabsList}
      backButtonText={backButtonText}
      handleBackClick={handleBackClick}
    />
  );
};

export default Project;
